import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import InitialScreen from './components/InitialScreen';
import LeaderSetup from './components/LeaderSetup';
import WaitingRoom from './components/WaitingRoom';
import GameScreen from './components/GameScreen';
import { useGameStore } from './store/gameStore';
import { socketService } from './services/socketService';

const App: React.FC = () => {
  const { gamePhase, gameRole, setGamePhase } = useGameStore();

  useEffect(() => {
    const socket = socketService.connect();

    socket.on('gameState', (state: any) => {
      console.log('Received game state in App:', state);
      if (state.phase && state.phase !== gamePhase) {
        console.log(`Updating game phase from ${gamePhase} to ${state.phase}`);
        setGamePhase(state.phase);
      }
    });

    return () => {
      socket.off('gameState');
    };
  }, [gamePhase, setGamePhase]);

  console.log('App render - gamePhase:', gamePhase, 'gameRole:', gameRole);

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            gamePhase === 'setup' && gameRole === 'leader' ? (
              <Navigate to="/leader-setup" replace />
            ) : gamePhase === 'waiting' && gameRole ? (
              <Navigate to="/waiting-room" replace />
            ) : gamePhase === 'playing' && gameRole ? (
              <Navigate to="/game" replace />
            ) : (
              <InitialScreen />
            )
          }
        />
        <Route
          path="/leader-setup"
          element={
            gamePhase === 'setup' && gameRole === 'leader' ? (
              <LeaderSetup />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/waiting-room"
          element={
            gamePhase === 'waiting' ? (
              <WaitingRoom />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/game"
          element={
            gamePhase === 'playing' && gameRole ? (
              <GameScreen />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
      </Routes>
    </Router>
  );
};

export default App; 